// Small presentation helpers shared across portal pages.

/** "2026-06-01" / "2026-06-01 12:00:00" → "Jun 1, 2026". Falsy → "—". */
export function fmtDate(value: string | null | undefined): string {
  if (!value) return '—'
  const d = new Date(value.includes('T') ? value : value.replace(' ', 'T'))
  if (Number.isNaN(d.getTime())) return value
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/** Integer cents → "$2,500.00". */
export function fmtCents(cents: number | null | undefined): string {
  const n = (cents ?? 0) / 100
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

/** snake_case / field_path → "Title Case". */
export function humanize(key: string): string {
  return key
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

/** A status string → CSS modifier class suffix (kebab). */
export function statusClass(status: string): string {
  return status.toLowerCase().replace(/[^a-z0-9]+/g, '-')
}
